import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIEditorToolbar from 'UIComponents/nav/UIEditorToolbar';
import { Flex } from 'foundations-components/components/Flex';
import { getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
import { addAlert } from 'automation-ui-canvas/actions/MessageActions';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { ACTION_SET_CONFIG } from 'automation-ui-canvas/constants/AbsolutePaths';
import * as AlertTypes from 'automation-ui-canvas/constants/AlertTypes';
import { ACTION_SETS_V2 } from 'automation-ui-canvas/constants/Gates';
import wireFlow from 'automation-ui-canvas/decorators/WiredFlowDecorator';
import Flow from 'automation-ui-canvas/flow/records/Flow';
import { updateFlowMutationCache } from 'automation-ui-canvas/queries/flowQueries';
import { setScrollToActionCardState } from 'automation-ui-canvas/utils/routingUtils';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import WorkflowNameWithDescription from 'automation-ui-management/components/WorkflowNameWithDescription';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useDataFetchingClient } from 'data-fetching-client';
import { stringify } from 'hub-http/helpers/params';
import { useDispatch } from 'react-redux';
import { generatePath, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionSetCanvasHeader = ({
  flow,
  location,
  history,
  match,
  readOnly
}) => {
  const dispatch = useDispatch();
  const client = useDataFetchingClient();
  const trackEvent = useTrackEvent();
  const isUngatedToActionSetsV2 = useIsUngated(ACTION_SETS_V2);
  if (!flow) {
    return null;
  }
  const onNameSaveSuccess = updatedFlowRecord => {
    updateFlowMutationCache(updatedFlowRecord, client.cache, dispatch);
  };
  const handleReturnRouting = () => {
    const search = new URLSearchParams(location.search);
    const sourceFlowId = search.get('sourceFlowId');
    const sourceEdgeId = search.get('sourceEdgeId');
    const actionSetId = match.params.flowId;
    if (!readOnly) {
      trackEvent(Trackables.SAVED_AND_EXITED_ACTION_SET, {
        numberOfActions: flow.getActionsAsList().length,
        flowObjectTypeId: flow.getObjectTypeId()
      });
      dispatch(addAlert(AlertTypes.SAVED_ACTION_SET_SUCCESS));
    }
    if (sourceFlowId && actionSetId) {
      history.push({
        pathname: generatePath(ACTION_SET_CONFIG, {
          flowId: sourceFlowId,
          actionSetId
        }),
        search: stringify({
          edgeId: sourceEdgeId,
          sourceFlowId
        })
      });
      if (sourceEdgeId) {
        const prevActionId = getPreviousActionId(sourceEdgeId);
        // Set timeout is necessary to defer the scrolling until full canvas is rendered. Otherwise, the decorator will handle the scrolling
        setTimeout(() => {
          setScrollToActionCardState(parseInt(prevActionId, 10), history, 'instant');
        }, 0);
      }
    } else {
      history.push('/');
    }
  };
  if (isUngatedToActionSetsV2) {
    return /*#__PURE__*/_jsx(UIEditorToolbar, {
      titleText: /*#__PURE__*/_jsx(WorkflowNameWithDescription, {
        flow: flow,
        hybridFlow: flow.toHybridFlowInterface(),
        flowId: flow.flowId,
        onNameSaveSuccess: onNameSaveSuccess,
        onHybridNameSaveSuccess: newFlow => onNameSaveSuccess(new Flow(newFlow)),
        hasDescriptionTooltip: true
      }),
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "link-on-dark",
          onClick: handleReturnRouting,
          children: !readOnly ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.header.save"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.header.exit"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.header.publish"
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(UIDialogHeader, {
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(WorkflowNameWithDescription, {
        flow: flow,
        title: /*#__PURE__*/_jsx("span", {
          role: "heading",
          "aria-level": 2,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.header.title",
            options: {
              flowName: flow.name
            }
          })
        }),
        hybridFlow: flow.toHybridFlowInterface(),
        flowId: flow.flowId,
        onNameSaveSuccess: onNameSaveSuccess,
        onHybridNameSaveSuccess: newFlow => onNameSaveSuccess(new Flow(newFlow)),
        hasDescriptionTooltip: true
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary-ghost",
        onClick: handleReturnRouting,
        children: !readOnly ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.actionSetCanvas.header.saveExitButton"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.actionSetCanvas.header.exit"
        })
      })]
    })
  });
};
export const WEBPACK_3_FORCE_MODULE_IMPORT = 1;
export default compose(withRouter, wireFlow)(ActionSetCanvasHeader);